// src/components/CoverPage/HeroSection.jsx
import React from "react";
import { Link } from "react-router-dom";
import Button from "./Button";

const HeroSection = ({ navigateToApp }) => {
  return (
    <section className="relative bg-gradient-to-b from-blue-900 to-indigo-800 px-5 py-32">
      <div className="mx-auto my-0 max-w-[1200px]">
        <div className="flex flex-col items-center text-center">
          <h1 className="mb-6 max-w-[800px] text-5xl sm:text-6xl font-bold text-white leading-tight">
            The Simplest Way to Invest in Crypto with Index Funds
          </h1>
          <p className="mb-8 max-w-[700px] text-xl leading-relaxed text-white text-opacity-90">
            YildX offers diversified crypto index funds with automatic rebalancing, transparent fees, and decentralized custody. Start investing today!
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              variant="primary" 
              onClick={navigateToApp}
              className="min-w-[180px] px-8"
            >
              See App
            </Button>
            <Link to="/learn">
              <Button 
                variant="secondary" 
                className="min-w-[180px] px-8"
              >
                Learn More
              </Button>
            </Link>
          </div>
        </div>
      </div>
      
      {/* Background elements */}
      <div className="absolute top-0 left-0 w-32 h-32 bg-white opacity-5 rounded-full -translate-x-1/2 -translate-y-1/2 blur-lg"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-indigo-400 opacity-10 rounded-full translate-x-1/3 translate-y-1/3 blur-xl"></div>
      <div className="absolute bottom-32 left-20 w-20 h-20 bg-blue-300 opacity-10 rounded-full blur-md"></div>
    </section>
  );
};

export default HeroSection;